<template>
  <a-tooltip placement="top" v-if="showToast">
    <template slot="title">
      <span>{{ columnText }}</span>
    </template>
    <div class="elipsisContent" v-bind:style="{ width: containPaddingWidth }">
      <span ref="textSpan"> {{ columnText }}</span>
    </div>
  </a-tooltip>
  <div class="elipsisContent" v-bind:style="{ width: containPaddingWidth }" v-else>
    <span ref="textSpan"> {{ columnText }}</span>
  </div>
</template>
<script>
export default {
  props: {
    columnText: String,
    width: String,
    padding: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showToast: false,
      containPaddingWidth: 0
    };
  },
  mounted() {
    let containPaddingWidth = Number(this.width.slice(0, -2))-2*this.padding
    this.containPaddingWidth = containPaddingWidth+'px'
    if (this.$refs.textSpan.offsetWidth < containPaddingWidth) {
      // 待处理
      this.showToast = true
    } else {
      this.showToast = true
    }
  }
};
</script>
<style lang="scss" scoped>
.elipsisContent {
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color:rgba(0,0,0,0.65);
  word-break: break-all;
  height: 19px;
  line-height: 19px;
}
</style>
